import {
  splitArray,
  getPathName,
  changeCurrancyFormat,
  changeDataFormat,
  getCurrentTime
} from "../../../../common/utils/utilsFunc";
import ClayTable from "@clayui/table";
import HeaderSearch from "../../../../common/components/HeaderSearch";
import HeaderTable from "../../../../common/components/HeaderTable";
import React, { useEffect, useState, useContext } from "react";
import CgeContextProvider, {
  CgeContext,
  ACTIONS,
} from "../../context/CgeContextProvider";
import arTitles from "../../../../common/services/mock/title.json";
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";
import Loading from "../../../../common/components/Loading";
import { LiferayService } from "../../../../common/services/liferay/index";
import { CGE } from "../../../../common/components/CGE";

const TablePaid = ({
  title,
  description,
  qtdRowPage,
  textNoResults,
  textFetchError,
  textLoadingBoleta,
  textFetchNoId,
  textAlertExcel,
  setGlobalAlert
}) => {
  const [state, dispatch] = useContext(CgeContext);
  const properties = useContext(ApplicationPropertiesContext);
  const [activePage, setActivePage] = useState(1);
  const [rowPage, setRowPageList] = useState(10);
  const [inputSearch, setInputSearch] = useState("");
  const [inputSelected, setInputSelected] = useState("");
  const [loading, setLoading] = useState(false);
  const [idBoletaByContext, setIdBoletaByContext] = useState("");
  const [errorToggle, setErrorToggle] = useState(false);
  const [loadingBoleta, setLoadingBoleta] = useState(false);

  let arrayOfarrays = [];
  let auxArray = [];
  let currentArray = [];
  let newArrTitle = arTitles[getPathName()]?.map((item) => item.label);
  let data = state.idList ? state.idList : [];

  if (state.dataPagos.code === 0) {
    auxArray = state.dataPagos.pagos;
  }

  //format auxArray, please don`t cut it
  const arrayTest = [...auxArray, auxArray?.map((aux) => {
    if (aux.fechaPago.split('-')[0].length === 4) {
      aux.fechaPago = changeDataFormat(aux.fechaPago);
    }
    if (aux.montoPagado[0] !== '$') {
      aux.montoPagado = changeCurrancyFormat(aux.montoPagado);
    }
  })]

  arrayOfarrays = auxArray ? splitArray(auxArray, rowPage) : [];
  currentArray = arrayOfarrays ? arrayOfarrays[activePage - 1] : [];

  useEffect(() => {
    setLoading(true);
    dispatch({
      payload: true,
      type: ACTIONS.SET_LOAD_PAGE,
    });
  }, []);

  useEffect(() => {
    if (inputSearch !== "") {
      if (data.find((o) => o === inputSearch)) {
        setInputSelected(inputSearch);
        document.getElementById("mySelectId").value = inputSearch;
        setErrorToggle(false);
      } else {
        dispatch({
          payload: null,
          type: ACTIONS.SET_IDCLIENT,
        });
        setInputSelected("");
        document.getElementById("mySelectId").value = "";
      }
    }
  }, [inputSearch]);

  useEffect(() => {
    if (inputSelected) {
      dispatch({
        payload: inputSelected,
        type: ACTIONS.SET_IDCLIENT,
      });
      setLoading(true);
      setErrorToggle(false);
      alertMsg();
      setInputSearch("");
    } else {
      dispatch({
        payload: null,
        type: ACTIONS.SET_IDCLIENT,
      });
      setInputSelected("");
      document.getElementById("mySelectId").value = "";
    }
  }, [inputSelected]);

  useEffect(() => {
    if (
      inputSelected ||
      inputSearch ||
      state.dataPagos.pagos ||
      state.dataPagos.status
    ) {
      setLoading(false);
    }
  }, [state.dataPagos]);

  useEffect(() => {
    if (state.idList) {
      setLoading(false);
    }
  }, state.idList);

  function alertMsg() {
    if ((!auxArray && inputSelected) || !inputSelected) {
      if(errorToggle && !inputSelected) {
        setGlobalAlert(textFetchNoId,"warning", true, "Advertencia")
      }
    }
  }

  function getBoletaBase64(idBoleta, docImpresion) {
    setIdBoletaByContext(idBoleta);
    let nrBoletaList = auxArray.map((obj) => obj["nroBoleta"]);
    if (nrBoletaList.filter((boleta) => boleta === idBoleta)[0] === idBoleta) {
      setLoadingBoleta(true);
    }
    LiferayService.getResponseDoc(properties.base_url_api, idBoleta,  properties.url_ws_empresa, properties.codigo_empresa,docImpresion)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_BASE64_BOLETA_BY_ID,
        });
        if(response.url) {
          window.open(response.boleta,"_blank")
        } else if (response?.code === 0) {
          let base64String = Buffer.from(response?.boleta, "hex").toString("base64");
          let link = document.createElement('a');
          link.download = `BoletaPagosRealizados_${getCurrentTime()}.pdf`;
          link.href = 'data:application/octet-stream;base64,'+base64String;
          link.click();
        }
      });
  }

  useEffect(() => {
    setLoadingBoleta(false);
    let msgAlertAux;
    if(state.boletaBase64?.mensaje) {
      msgAlertAux = state.boletaBase64?.mensaje;
    } else {
      msgAlertAux = textFetchError;
    }
    
    if (state.boletaBase64?.code && state.boletaBase64?.code !== 0) {
      setGlobalAlert(msgAlertAux,"warning", true, "Advertencia");
    } else if (state.boletaBase64?.status) {
      setGlobalAlert(msgAlertAux,"warning", true, "Advertencia");
    }
  }, [state.boletaBase64]);


  function setRowPage(nPage) {
    setActivePage(1);
    setRowPageList(Number(nPage));
  }

  let propsTable = {
    'title': title,
    'description': description,
    'setActivePage': setActivePage,
    'qtdRowPage': qtdRowPage,
    'setRowPage': setRowPage,
    'rowPage': rowPage,
    'activePage': activePage,
    'auxArray': auxArray,
    'arTitles': arTitles,
    'excelBtn': true,
    'showPagination':false
  }

  React.useEffect(() => {
    if(state?.dataPagos?.pagos?.length > 0) {
      if(!loading && !inputSelected && !inputSearch) {
        setGlobalAlert(textNoResults,"warning", true, "Advertencia")
      }
    } else if (state?.dataPagos?.error) {
      setGlobalAlert(textFetchError,"warning", true, "Advertencia");

    } else if (state?.dataPagos?.status) {

      setGlobalAlert(textFetchError,"warning", true, "Advertencia");
    } else if (state?.dataPagos?.code !== 0) {

      setGlobalAlert(state?.dataPagos?.mensaje,"warning", true, "Advertencia");
    }

  },[state.dataPagos]);

  React.useEffect(() => {
    if(state.errorFetch) {
      setGlobalAlert(textFetchError,"warning", true, "Advertencia")
      setLoading(false);
    }
  },[state.errorFetch]);
  
  return (
    <>
      <HeaderSearch
        data={data}
        setSearch={setInputSearch}
        setSelected={setInputSelected}
        idClient={inputSelected}
        inputSearch={inputSearch}
        
      />
      <CGE.Panel>
        <HeaderTable props={propsTable} />
        <ClayTable
          class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle"
          id="table-to-xls"
        >
          <ClayTable.Head>
            <ClayTable.Row>
              {newArrTitle?.map((title) => {
                return (
                  <ClayTable.Cell
                    className="clientCell font-weight-bold"
                    headingCell
                  >
                    {title}
                  </ClayTable.Cell>
                );
              })}
            </ClayTable.Row>
          </ClayTable.Head>
          <ClayTable.Body>
            {auxArray && inputSelected && !loading ? (
              auxArray?.map((obj) => {
                return (
                  <ClayTable.Row className="tableRow">
                    {Object.keys(obj).map((index) => {
                       if (index !== "docImpresion") {
                      return (
                        <ClayTable.Cell
                          className=" txt-with-link clientCell-td table-cell-minw-150 table-cell-expand text-truncate"
                          title={obj[index].length > 23 ? obj[index] : ""}
                        >
                          {index === "nroBoleta" ? (
                            <div className="d-flex align-items-center">
                              <a
                                id="clickMe"
                                className="text-decoration-none"
                                target="_blank"
                                onClick={() =>
                                  getBoletaBase64(obj["nroBoleta"], obj["docImpresion"])
                                }
                              >
                                {obj[index]}
                              </a>
                              {obj["nroBoleta"] === idBoletaByContext &&
                                loadingBoleta && <Loading isSmall />}
                            </div>
                          ) :
                            (
                              obj[index]
                            )}
                        </ClayTable.Cell>
                        );
                      }
                      return null;
                    })}
                  </ClayTable.Row>
                );
              })
            ) : (
              <ClayTable.Row>
                <ClayTable.Cell
                  colspan={newArrTitle?.length}
                  className="text-no-results  font-weight-bold"
                >
                </ClayTable.Cell>
              </ClayTable.Row>
            )}
          </ClayTable.Body>
        </ClayTable>
        {loading && <Loading />}
      </CGE.Panel>
    </>
  );
};

const TablePaidWithProvider = ({
  title,
  description,
  qtdRowPage,
  textNoResults,
  textFetchError,
  textLoadingBoleta,
  textFetchNoId,
  textAlertExcel,
  setGlobalAlert
}) => (
  <CgeContextProvider>
    <TablePaid
      title={title}
      description={description}
      qtdRowPage={qtdRowPage}
      textNoResults={textNoResults}
      textFetchError={textFetchError}
      textLoadingBoleta={textLoadingBoleta}
      textFetchNoId={textFetchNoId}
      textAlertExcel={textAlertExcel}
      setGlobalAlert={setGlobalAlert}
    />
  </CgeContextProvider>
);
export default TablePaidWithProvider;
